module.exports = __webpack_public_path__ + "static/img/fa-nan@2x.dd7ffe3b.png";